// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** Supported action types for PlanCalendarNudgeStore registration. */ export const PlanCalendarNudgeStoreActionTypes = [
    ActionType.DismissPlanCalendarNudgeAction
];
